<template>
    <div class="relative">
        <vue-extend-layouts />
    </div>
</template>
<style>
    .relative{
        position: relative;
    }
    .saudacao {
        display: none !important;
    }

    @media screen and (max-width: 768px) {
        #main.main-full {
            padding-left: 0;
        }
    }
</style>

<script>
import Flash from '@/helpers/flash';
import Auth from '@/store/auth';
import { interceptors  } from '@/helpers/api';

import VueExtendLayouts from 'vue-extend-layout'

import modal from "@/helpers/wm-modal.js";

export default {
    name: 'App',
    data: () => ({
        sLoading: false,
        message:{
            title: '',
            message: '',
            typeMessage: 'danger',
        }
    }),
    components: {
        VueExtendLayouts
    },
    created() {

        // global error http handler
        interceptors((err) => {

            console.log(err.config);
            if (!err.config || err.config.disableInterceptor) {
                return;
            }


            switch (err.response.status) {
                case 401:
                    Auth.remove();
                    this.$router.push('/login');
                    break;

                case 404:
                    this.$router.push('/not-found');
                    break;

                case 422:
                    var key = Object.keys(err.response.data.errors)[0];
                    modal.alert({title: 'Ops! Erros de validação encontrados', text: err.response.data.errors[key][0]})
                    break;

                case 400:
                    modal.alert({text: err.response.data.statusMessage, title: 'Ops! Ocorreu um erro'})
                    break

                default:
                    modal.alert({text: err.response.statusText})
                    break;
            }
        });
    },

    computed: {
        auth() {
            return !!this.authState.api_token
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue